export default __webpack_public_path__ + "images/activity_illustration.abec0532d9e0cc35515cdd00deae951e.svg";